import styled from "@emotion/styled";

export const StyledFileRow = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return "isOpen" !== propName;
        },
    }
)<{ isOpen: boolean }>(({ theme, isOpen }) => ({
    display: "flex",
    padding: theme.spacing(2, 3),
    columnGap: theme.spacing(2),
    alignItems: "center",
    width: "100%",
    borderBottom: isOpen ? "none" : "1px solid",
    borderColor: theme.kaltura.palette.tone4,
}));

export const StyledEditFormWrapper = styled(
    "div",
    {
        shouldForwardProp: (prop) => prop !== "singleUpload",
    }
)<{ singleUpload?: boolean }>(({ theme, singleUpload }) => ({
    width: "100%",
    ...(singleUpload
        ? {
              padding: theme.spacing(0, 2, 2, 2),
              marginTop: theme.spacing(-3),
          }
        : {
              padding: theme.spacing(1, 2, 2), // padding to match the previous accordion summary layout
          }),
}));
